import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IProject } from '../types/IProject';
import { IUser } from '../types/IUser';

export interface IGetProjectsParams extends IGetItemsParams {
}

export interface IGetProjectsResult extends IGetItemsResult {
  projects?: IProject[];
  users?: IUser[];
  favorites?: string[];
}

export class GetProjectsRequest extends Request<IGetProjectsParams, IGetProjectsResult> {
  constructor(params: IGetProjectsParams) {
    super('getProjects', params);
  }
}
